export default function SectionHead({
  kicker,
  title,
  sub,
  id,
}: {
  kicker: string;
  title: string;
  sub: string;
  id?: string;
}) {
  return (
    <div className="mb-6 flex flex-col gap-2 md:mb-8">
      <span className="inline-flex w-fit items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
        <i className={`ri-${kicker}`} aria-hidden="true" />
        {kicker}
      </span>
      <div className="flex flex-col justify-between gap-2 md:flex-row md:items-end">
        <h2 id={id} className="scroll-mt-24 font-heading text-xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        <p className="max-w-md text-sm text-foreground-500">{sub}</p>
      </div>
    </div>
  );
}